// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zHS4IQpP5AbwXnrIUZnL{height:100%;width:100%;display:flex;align-items:center;justify-content:center;position:relative}.FuMOB_DQdQDz9pyx8ksD._Z459S489Kj1B2L1A_4Q{width:100%}.FuMOB_DQdQDz9pyx8ksD._Z459S489Kj1B2L1A_4Q button{width:100%}.FuMOB_DQdQDz9pyx8ksD>div{position:relative;display:flex;box-shadow:0px 1px 2px 0px rgba(184,186,202,.5);border-radius:22px;border:1px solid var(--color-default);padding:10px;margin:0 5px;gap:12px}.FuMOB_DQdQDz9pyx8ksD>div:before{z-index:0;content:"";position:absolute;top:50%;left:10px;border-top:1px solid var(--color-515-granat);background:#000;width:calc(100% - 20px)}.FuMOB_DQdQDz9pyx8ksD>div button{z-index:1;margin:0;box-shadow:none;padding:5px 10px;max-width:100%;font-size:14px;font-weight:700;line-height:16px;border:1px solid rgba(0,0,0,0);color:var(--color-515-baly);background:var(--color-515-granat)}.FuMOB_DQdQDz9pyx8ksD>div button>span{white-space:nowrap}.FuMOB_DQdQDz9pyx8ksD>div button:hover{border-color:var(--color-primary) !important}.FuMOB_DQdQDz9pyx8ksD>div button.JJhEz4JWwYt7h6oVT0Ag{background:var(--color-primary);color:var(--color-white)}.FuMOB_DQdQDz9pyx8ksD>div button.SJIrKkx1aTqjDm3T_mvw{background:var(--color-default-extra-light)}.FuMOB_DQdQDz9pyx8ksD>div button.SJIrKkx1aTqjDm3T_mvw:hover,.FuMOB_DQdQDz9pyx8ksD>div button.SJIrKkx1aTqjDm3T_mvw:focus{border-color:rgba(0,0,0,0)}.FuMOB_DQdQDz9pyx8ksD>span{font-size:12px;line-height:16px;font-weight:700}.FuMOB_DQdQDz9pyx8ksD>span div{margin-left:5px}.FuMOB_DQdQDz9pyx8ksD.ZXyY2I2wYtMlaI7SlPRa>div{margin:7px 5px 0}.FuMOB_DQdQDz9pyx8ksD.wuEgBiUdajrMpdmxXmAx{display:flex;align-items:center;margin-left:25px}.FuMOB_DQdQDz9pyx8ksD.wuEgBiUdajrMpdmxXmAx>span{margin-right:17px}.FuMOB_DQdQDz9pyx8ksD.o_bKb61Du7fgwMnZ3V_j>div{padding:3px 3px}.FuMOB_DQdQDz9pyx8ksD.o_bKb61Du7fgwMnZ3V_j button{padding:0 5px;line-height:12px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary-dark": `#e73b05`,
	"primary": `#ff6040`,
	"primary-light": `#ffe4df`,
	"primary-extra-light": `#fff2f0`,
	"secondary-dark": `#8292b1`,
	"secondary": `#99a8c6`,
	"secondary-light": `#d0dae9`,
	"secondary-extra-light": `#eef4fc`,
	"default-dark": `#898ca7`,
	"default": `#b8baca`,
	"default-light": `#ecedf5`,
	"default-extra-light": `#f8f8f8`,
	"warning-dark": `#d96800`,
	"warning": `#fbab00`,
	"warning-light": `#ffeba3`,
	"warning-extra-light": `#fff5d1`,
	"info-dark": `#0a82c6`,
	"info": `#2eb6ea`,
	"info-light": `#beebfc`,
	"info-extra-light": `#dff5fe`,
	"success-dark": `#069941`,
	"success": `#3aaa35`,
	"success-light": `#c6f1c3`,
	"success-extra-light": `#e3f9e1`,
	"danger-dark": `#cd0101`,
	"danger": `#ff4141`,
	"danger-light": `#ffcece`,
	"danger-extra-light": `#ffe7e7`,
	"text-primary": `#131a4f`,
	"text-secondary": `#8292b1`,
	"shadow-25": `rgba(184,186,202,.25)`,
	"shadow-50": `rgba(184,186,202,.5)`,
	"root": `zHS4IQpP5AbwXnrIUZnL`,
	"buttonsGroup": `FuMOB_DQdQDz9pyx8ksD`,
	"fullWidth": `_Z459S489Kj1B2L1A_4Q`,
	"active": `JJhEz4JWwYt7h6oVT0Ag`,
	"disabled": `SJIrKkx1aTqjDm3T_mvw`,
	"top": `ZXyY2I2wYtMlaI7SlPRa`,
	"left": `wuEgBiUdajrMpdmxXmAx`,
	"extraSmall": `o_bKb61Du7fgwMnZ3V_j`
};
export default ___CSS_LOADER_EXPORT___;
